export enum TrackType {
    Global,
    Dancer,
}

export enum GlobalTrackType {
    Music,
    Ambience,
    Foley
}

export enum DancerTrackType {
    Path,
    AboveHead,
    Head,
    Torso,
    Legs,
    Ground,
}

export interface IGlobalTrackId {
    trackType: TrackType.Global;
    type: GlobalTrackType; 
}

export interface IDancerTrackId {
    trackType: TrackType.Dancer;
    type: DancerTrackType;
    dancerId: number;
}

export type ITrackId = IGlobalTrackId | IDancerTrackId;
